import { cn } from "@/lib/utils";
import { statisticsSidebarSurfaceCardClassName } from "../Statistics/components/statisticsShadcnCardShell";

export const courseOverviewMainCardClassName = cn(
  "flex w-full min-w-0 flex-col gap-6 rounded-[6px] border border-solid border-border bg-card p-4 text-card-foreground shadow-none !ring-0",
  statisticsSidebarSurfaceCardClassName,
);

/** Lesson page main shell — same stroke as course overview, no inner padding. */
export const courseLearnMainCardClassName = cn(
  courseOverviewMainCardClassName,
  "!gap-0 !p-0",
);

export const universityCourseBodyTextClassName =
  "font-[family-name:var(--font-primary)] text-sm font-normal leading-relaxed text-gray-500";

export const universityCourseMutedTextClassName =
  "font-[family-name:var(--font-primary)] font-normal text-gray-500";

export const universityCourseFieldLabelClassName =
  "font-[family-name:var(--font-primary)] font-medium text-[color:var(--brand-tropical-surf)]";

/** Matches lesson card Field title → description spacing. */
export const universityCourseFieldStackClassName = "flex flex-col gap-1.5";

export const universityCourseAccordionTriggerClassName =
  "w-full items-center py-4 font-medium hover:no-underline [&_[data-slot=accordion-trigger-icon]]:ml-3 [&_[data-slot=accordion-trigger-icon]]:shrink-0";
